// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    off: {
        id: 'picker.rgb-flipper-off',
        defaultMessage: 'Off'
    },
    on: {
        id: 'picker.rgb-flipper-on',
        defaultMessage: 'On {brightness}%'
    },
    coolest: {
        id: 'picker.white-mode-coolest',
        defaultMessage: 'coolest white'
    },
    cool: {
        id: 'picker.white-mode-cool',
        defaultMessage: 'cool white'
    },
    mid: {
        id: 'picker.white-mode-mid',
        defaultMessage: 'mid white'
    },
    warm: {
        id: 'picker.white-mode-warm',
        defaultMessage: 'warm white'
    },
    warmest: {
        id: 'picker.white-mode-warmest',
        defaultMessage: 'warmest white'
    }
});



// WEBPACK FOOTER //
// ./src/core/i18n/components/widgets/flipper/intl.js